<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">报备列表</p>
      <div class="search">
        <!-- 详细筛选条件 -->
        <div>
          <div
            class="search-detail"
            :class="{ 'search-detail-close': !searchVisible }"
            :style="{ overflow: !searchVisible ? 'hidden' : '' }"
          >
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入企业名称"
                v-model="searchForm.name"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入corpID"
                v-model="searchForm.corpid"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入联系人"
                v-model="searchForm.name"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入手机号码"
                v-model="searchForm.phone"
              ></Input>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择到期时间'"
                :value="emptyDate"
                @on-change="
                  daterangeChange(
                    $event,
                    'serviceExpireTimeStart',
                    'serviceExpireTimeEnd'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择所属行业"
                element-id="industryType"
                v-model="searchForm.industryType"
              >
                <Option
                  v-for="spareType in busType"
                  :key="spareType.value"
                  :value="spareType.value + ''"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择客户状态"
                element-id="reportState"
                v-model="chouseState"
              >
                <Option
                  v-for="spareType in packageNumber"
                  :key="spareType.value"
                  :value="spareType.value + ''"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                multiple
                class="search-input"
                placeholder="请选择套餐人数"
                element-id="packageId"
                v-model="packageId"
              >
                <Option
                  v-for="spareType in buyPeople"
                  :key="spareType.value"
                  :value="spareType.value + ''"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入业务员"
                v-model="searchForm.salemanName"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Button
                type="primary"
                class="search-button"
                @click=";(pageIndex = 0), loadList()"
              >
                查找
              </Button>
              <Button class="search-button" @click="resetSearchForm">
                重置
              </Button>
              <FilterColumn
                class="search-button"
                :column="allColumns"
                @columnsChecked="columnsChecked = $event"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table table-sticky">
        <Table
          stripe
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
        ></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      columnsChecked: [],
      orderModalShow: false, // 购买弹窗
      chouseState: '',
      currPackageId: 1,
      buyPeople: '',
      busType: '',
      corpid: '',
      type: 1,
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      emptyDate: ['', ''],
      searchForm: {
        corpid: '',
        name: '',
        phone: '',
        salemanName: '',
        serviceExpireTimeStart: '',
        serviceExpireTimeEnd: '',
        industryType: '',
        reportState: '',
        packageIds: '',
      },
      packageNumber: [
        {
          value: '1',
          name: '报备中',
        },
        {
          value: '2',
          name: '免费版',
        },
        {
          value: '3',
          name: '试用版',
        },
        {
          value: '4',
          name: 'VIP版',
        },
        {
          value: '5',
          name: 'VIP到期',
        },
        {
          value: '6',
          name: '报备失败',
        },
      ],
      packageId: [],
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    // 表格列 根据选中的列动态生成
    allColumns() {
      const allColumns = [
        {
          title: '所属渠道经理',
          key: 'channelName',
          width: 140,
        },
        {
          title: '企业名称',
          key: 'enterpriseName',
          width: 140,
        },
        {
          title: 'CorpID',
          key: 'corpid',
          width: 140,
          ellipsis: true,
        },
        {
          title: '联系人',
          key: 'name',
          width: 100,
        },
        {
          title: '手机号码',
          key: 'phone',
          width: 140,
        },
        {
          title: '所属地区',
          key: 'create_time',
          width: 160,
          render: (h, { row }) => {
            let address = row.provName + row.cityName
            return h('span', [address])
          },
        },
        {
          title: '所属行业',
          key: 'industryName',
          width: 140,
        },
        {
          title: '代理商',
          key: 'agentName',
          width: 140,
        },
        {
          title: '代理商业务员',
          key: 'salemanName',
          width: 140,
        },
        {
          title: '客户状态',
          key: 'reportState',
          width: 120,
          render: (h, { row }) => {
            let priority = row.reportState
            let priorityName = ''
            if (priority === 1) {
              priorityName = '报备中'
            } else if (priority === 2 && row.isChargeUser === 0) {
              priorityName = '免费版'
            } else if (
              priority === 2 &&
              row.isChargeUser === 1 &&
              row.isServiceExpire === 1
            ) {
              priorityName = 'VIP版本过期'
            } else if (priority === 2 && row.isChargeUser === 1) {
              priorityName = 'VIP版'
            } else if (priority === 2 && row.isChargeUser === 2) {
              priorityName = 'VIP试用版'
            } else if (priority === 3) {
              priorityName = '报备失败'
            }
            return h('span', [priorityName])
          },
        },
        {
          title: '套餐人数',
          key: 'packageName',
          width: 140,
          render: (h, { row }) => {
            let packageNum = ''
            if (row.reportState === 1 || row.reportState === 3) {
              packageNum = '-'
            } else {
              packageNum = row.packageName
            }
            return h('span', [packageNum])
          },
        },
        {
          title: '到期时间',
          key: 'serviceExpireTime',
          width: 160,
          render: (h, { row }) => {
            let packageNum = ''
            if (row.reportState === 1 || row.reportState === 3) {
              packageNum = '-'
            } else {
              packageNum = row.serviceExpireTime
            }
            return h('span', [packageNum])
          },
        },
        {
          title: ' ',
          key: ' ',
        },
      ]
      return allColumns
    },
    columns() {
      const allColumns = this.allColumns
      let arr = allColumns.filter((col) => {
        if (!col.key || !col.key.trim()) {
          return true
        } else {
          if (this.columnsChecked.length) {
            return this.columnsChecked.includes(col.key)
          } else {
            return true
          }
        }
      })
      if (this.columnsChecked.length) {
        let indexMap = this.columnsChecked.reduce((p, c, i) => {
          p[c] = i
          return p
        }, {})
        let left = arr.filter((col) => this.columnsChecked.includes(col.key))
        let right = arr.filter((col) => !this.columnsChecked.includes(col.key))
        arr = left
          .sort((p, c) => indexMap[p.key] - indexMap[c.key])
          .concat(right)
      }
      return arr
    },
  },
  watch: {
    chouseState(val) {},
  },
  methods: {
    // 加载列表数据
    loadList() {
      if (this.chouseState === '1') {
        this.searchForm.reportState = 1
      } else if (this.chouseState === '2') {
        this.searchForm.reportState = 2
        this.searchForm.isChargeUser = 0
      } else if (this.chouseState === '3') {
        this.searchForm.reportState = 2
        this.searchForm.isChargeUser = 1
        this.searchForm.isServiceExpire = 1
      } else if (this.chouseState === '4') {
        this.searchForm.reportState = 2
        this.searchForm.isChargeUser = 1
      } else if (this.chouseState === '5') {
        this.searchForm.reportState = 2
        this.searchForm.isChargeUser = 2
      } else if (this.chouseState === '6') {
        this.searchForm.reportState = 3
      }
      this.searchForm.packageIds = this.packageId.join(',')
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/customer/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/customer/count', {
            params: this.searchForm,
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyDate = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm() {
      this.chouseState = ''
      this.emptyDate = ['', '']
      this.searchForm = {
        corpid: '',
        name: '',
        phone: '',
        salemanName: '',
        industryType: '',
        reportState: '',
        packageIds: '',
      }
      this.packageId = []
      this.loadList()
    },
  },
  created() {
    this.$http.get('/dropdown/industry').then((res) => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then((res) => {
      this.buyPeople = res.data
    })
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    height: 120px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        // margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/customList/index.vue